<template>
  <div>
    <canvas id="planet-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: "PlanetChart",
  props:['chartLabel','chartData','chartMin','chartMax'],
  data: function () {
    return {
      planetChartData: {
        type: "line",
        data: {
          labels:this.log2(),
          datasets: [
            { // one line graph
              data:this.log()  ,
              backgroundColor: [
                'rgba(54,73,93,.5)', // Blue
              ],
              borderColor: [
                '#36495d',
              ],
              borderWidth: 3
            },
          ]
        },
        options: {
          legend: {
            display: false
          },
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [{
              ticks: {
                min: this.chartMin,
                max: this.chartMax,
                stepSize: 10000,
                reverse: false,
                beginAtZero: true
              }
            }]
          }
        }
      }
    }
  },
  created() {

  },

  mounted() {
    const ctx = document.getElementById('planet-chart');
    new Chart(ctx, this.planetChartData);
    console.log(this.chartData)
    console.log(this.chartLabel)

  },
  methods:{
    log() {
      let arr = this.chartData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    log2() {
      let arr = this.chartLabel ;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
  }
}
</script>

<style scoped>

</style>
